<template>
  <div>
    <v-container>
      <h1>Create</h1>
      <v-row>
        <v-col cols="12" sm="6" md="3" :class="classPadding">
          <v-text-field
            label="User"
            v-model="payLoc.empCode"
            readonly
            clearable
            @click:clear="payLoc = {}"
            autocomplete="off"
          >
            <template slot="append">
              <v-icon @click.stop="searchUser">mdi-magnify</v-icon>
              <span class="required">*</span>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Employee Name"
            v-model="payLoc.fullName"
            readonly
            autocomplete="off"
          ></v-text-field>
        </v-col>
      </v-row>
      <pay-loc-pagination
        :show-dense="false"
        :headers="payLocHeaders"
        :show-select="true"
      ></pay-loc-pagination>
      <v-row>
        <v-col>
          <v-btn
            color="success"
            @click.stop="save"
            :loading="isSaving"
            v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <v-dialog width="700" v-model="userDialog">
      <users-pagination :show-dense="false" :headers="usersHeaders">
        <template slot="actions" slot-scope="{ item }">
          <v-btn text @click.stop="selectUser(item)">Select</v-btn>
        </template>
        <template slot="card-actions">
          <v-spacer></v-spacer>
          <v-btn text @click.stop="userDialog = false" color="error"
            >close</v-btn
          >
        </template>
      </users-pagination>
    </v-dialog>
  </div>
</template>
<script>
// import PayLocPagination from "../../setup/general/payroll-location/Pagination";
import PayLocPagination from "../../setup/general/payroll-location/PaginationSelection";
import UsersPagination from "../../admin/users/PaginatedList";
import EventBus from "../../../events/eventBus";
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/userAccess";

export default {
  metaInfo: {
    title: "Create Payroll Location Group Access",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    PayLocPagination,
    UsersPagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    payLoc: {},
    userDialog: false,
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ],
    usersHeaders: [
      {
        text: "",
        sortable: false,
        value: "action"
      },
      {
        text: "Emp Code",
        align: "left",
        sortable: false,
        value: "empCode"
      },
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "fullName"
      }
    ],
    isSaving: false,
    selectedPayLoc: []
  }),
  methods: {
    searchUser() {
      this.userDialog = true;
    },
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}/payloc-group-access`, {
          IDs: this.selectedPayLoc,
          EmpCode: this.payLoc.empCode
        })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.$router.push("/payloc-group-access");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    selectUser({ empCode, fullName }) {
      this.payLoc.empCode = empCode;
      this.payLoc.fullName = fullName;
      this.userDialog = false;
    },
    clearUser() {
      this.payLoc.empCode = "";
      this.payLoc.fullName = "";
      this.userDialog = false;
    }
  },
  mounted() {
    EventBus.$on("SELECTED_PAYLOC", val => {
      this.selectedPayLoc = val;
    });
  },
  created() {
    this.getUserAccessRights("AddUsrGrp");
  }
};
</script>